import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";
import "../../styles/supportUs.css";
import QRCode from "../../../assets/qr-code-temp.png"; // ganti ke QR Code asli
import KaosForpasi from '../../../assets/Kaos poster.png'
import ForpasiKepri from '../../../assets/forpasi kepri.jpg'
import ForpasiBuku from '../../../assets/buku-panduan.png'

const SupportUsSection = () => {
  const { language } = useLanguage();

  const content = {
    id: {
      title: "Mari melangkah bersama FORPASI", 
      subtitle: "Mari melangkah bersama FORPASI untuk mewujudkan sistem persampahan yang lebih baik",
      bank: "Bank BRI 020601011054569 atas nama Yayasan Asa Indonesia Lestari",
      wa: "Konfirmasi transfer ke email: yayasanasaindonesialestari@gmail.com",
      merchTitle: "Dukung FORPASI dengan pesan merchandise (Kaos FORPASI)",
      merchText: "Formulir pemesanan kaos FORPASI",
      merchLink: "https://docs.google.com/forms/d/1CElEmRdhDU1Fu8J5x6WmGnTP3yfYr1-fYwFm5spB73c/viewform?edit_requested=true",
      donationTitle: "Dukung FORPASI melalui donasi kegiatan",
      qrisText: "Scan QRIS di atas untuk donasi via e-wallet atau mobile banking Anda.",
      bookTitle: "Dukung dengan pesan BUKU PANDUAN RUMAH BEBAS SAMPAH",
      bookText: "Kolaborasi dan pemesanan: Silahkan kunjungi email yayasan",
      korwilTitle: "Dukung FORPASI dengan menjadi Koordinator Wilayah (Korwil)",
      korwilText: "Formulir pendaftaran KORWIL FORPASI",
      korwilLink: "https://docs.google.com/forms/d/1LdzfrCSVkz2NH5RmFYBKqE2-VUrAmqiFx0o4PEHsIxA/edit",
      korwilCaption: "Foto kegiatan KORWIL KEPRI, David Christian Hutagaol (Provinsi Kepulauan Riau)",
    },
    en: {
      title: "Be a Hero for the Environment",
      subtitle: "Let's move forward together with FORPASI to create a better waste management system.",
      bank: "Bank BRI 020601011054569 under Yayasan Asa Indonesia Lestari",
      wa: "Confirm transfer via email: yayasanasaindonesialestari@gmail.com",
      merchTitle: "Support FORPASI by ordering merchandise (FORPASI T-shirt)",
      merchText: "FORPASI T-shirt order form",
      merchLink: "https://docs.google.com/forms/d/1CElEmRdhDU1Fu8J5x6WmGnTP3yfYr1-fYwFm5spB73c/viewform?edit_requested=true",
      donationTitle: "Support FORPASI through activity donations",
      qrisText: "Scan the QRIS above to donate via your e-wallet or mobile banking.",
      bookTitle: "Support by ordering the ZERO WASTE HOME GUIDEBOOK",
      bookText: "Collaboration and ordering: Please visit the email of the foundation",
      korwilTitle: "Support FORPASI by becoming a Regional Coordinator (Korwil)",
      korwilText: "KORWIL FORPASI registration form",
      korwilLink: "https://docs.google.com/forms/d/1LdzfrCSVkz2NH5RmFYBKqE2-VUrAmqiFx0o4PEHsIxA/edit",
      korwilCaption: "Photo of KORWIL KEPRI activity, David Christian Hutagaol (Riau Islands Province)",
    },
  };

  const t = content[language] || content.id;

  return (
    <section className="supportus-section">
      <div className="supportus-container">
        <div className="supportus-intro">
          <h2 className="supportus-title">{t.title}</h2>
          <p className="supportus-subtitle">{t.subtitle}</p>
        </div>

        <div className="supportus-info">
          <div className="info-stack">
            <div className="support-card merch-block">
              <h3 className="support-card-title">{t.merchTitle}</h3>
              <p>
                <a href={t.merchLink} target="_blank" rel="noopener noreferrer">
                  {t.merchText}
                </a>
              </p>
              <img src={KaosForpasi} alt="Kaos FORPASI" className="merch-image" />
            </div>

            <div className="support-card donation-block">
              <h3 className="support-card-title">{t.donationTitle}</h3>
              <p className="black-bold">{t.bank}</p>
              <p className="black-bold">{t.wa}</p>
              <div className="qr-block">
                <img src={QRCode} alt="QRIS" className="supportus-qr" />
                <p className="qr-caption">{t.qrisText}</p>
              </div>
            </div>

            <div className="support-card book-block">
              <h3 className="support-card-title">{t.bookTitle}</h3>
              <p className="card-text">{t.bookText}</p>
              <img src={ForpasiBuku} alt="Buku Panduan Rumah Bebas Sampah" className="merch-image" />
            </div>

            <div className="support-card korwil-block">
              <h3 className="support-card-title">{t.korwilTitle}</h3>
              <p>
                <a href={t.korwilLink} target="_blank" rel="noopener noreferrer">
                  {t.korwilText}
                </a>
              </p>
              <img src={ForpasiKepri} alt="Foto KORWIL FORPASI" className="korwil-image" />
              <p className="caption">{t.korwilCaption}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SupportUsSection;
